import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useProject } from "@/components/projects";
import { Card, CardContent } from "@/components/ui/card";
import { PageHeader } from "@/components/layout";
import { TakeoffPilotJobForm } from "@/features/takeoff-pilot/takeoff-pilot-job-form";
import { useAppNavigate } from "@/lib/use-app-navigate";
import { EditAccessGate } from "@/features/onboarding";

export const Route = createFileRoute("/takeoffPilot/new")({
  component: NewTakeoffPilotPage,
});

export function NewTakeoffPilotPage() {
  return (
    <EditAccessGate>
      <NewTakeoffPilotPageContent />
    </EditAccessGate>
  );
}

function NewTakeoffPilotPageContent() {
  const navigate = useAppNavigate();
  const { projectId, isLoading: isProjectLoading } = useProject();

  useEffect(() => {
    if (!isProjectLoading && !projectId) {
      navigate({ to: "/projects", title: "Projects" });
    }
  }, [isProjectLoading, projectId, navigate]);

  if (isProjectLoading) {
    return null;
  }

  return (
    <div className="space-y-4">
      <PageHeader
        title="New TakeoffPilot Job"
        trail={[{ label: "TakeoffPilot", href: "/takeoffPilot" }]}
        description="Pick plan documents, optionally attach a schedule, and export the takeoff table."
      />

      <Card className="max-w-3xl">
        <CardContent>
          <TakeoffPilotJobForm
            onSuccess={(jobId) =>
              navigate({
                to: "/takeoffPilot/$jobId",
                params: { jobId },
                title: "Takeoff Job",
              })
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}
